import React from "react";
import dynamic from "next/dynamic";
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"), { ssr: true });

// Disable SSR for client-only components
const IndustryTabs = dynamic(() => import("./CaseStudiesTabs"));
const IndustryTabsGreen = dynamic(() => import("./CaseStudiesTabsGreen"));

type CaseStudy = {
  id: number;
  title: string;
  Description: string;
  image: {
    url: string;
  };
  link: {
    href: string;
    label: string;
  };
};

type CaseCardItem = {
  id: number;
  CaseStudy: CaseStudy[];
};

type CaseStudiesBlock = {
  title?: string;
  sub_title?: string;
  CaseCard: CaseCardItem[];
};

export interface CaseStudiesBlockProps {
  data?: CaseStudiesBlock;
}

const CaseStudies: React.FC<CaseStudiesBlockProps> = ({ data }) => {
  return (
    <Section className="enterprise-impact">
      <div className="container">
        <div className="xl:max-w-[910px] mx-auto text-center">
          <h2 className="text-heading-1 text-primary-text font-bold capitalize">
            {data?.title}
          </h2>
          <p className="text-subtitle-2 font-regular mt-3">{data?.sub_title}</p>
        </div>
        <>
          {data?.CaseCard?.map((caseCard, index) => {
            if (index % 2 === 0) {
              return (
                <div key={index} className="xl:mt-10 mt-8">
                  <IndustryTabs CaseCard={[caseCard]} />
                </div>
              );
            } else {
              return (
                <div key={index} className="xl:mt-16 mt-8">
                  <IndustryTabsGreen CaseCard={[caseCard]} />
                </div>
              );
            }
          })}
        </>
      </div>
    </Section>
  );
};
export default React.memo(CaseStudies);